/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {TheCageGameAssets} from "./TheCageGameAssets";
import {TheCageSound} from "./sound/TheCageSound";
import {TheCageBackgroundElements} from "./view/TheCageBackgroundElements";
import {TheCageWinPresentation} from "./gameflow/TheCageWinPresentation";
import {TheCageBetPresentation} from "./gameflow/TheCageBetPresentation";
import {TheCageNormalResultPresentation} from "./gameflow/TheCageNormalResultPresentation";
import {TheCageIdleNormalPresentation} from "./gameflow/TheCageIdleNormalPresentation";
import {TheCageAvalancheIdlePresentation} from "./gameflow/TheCageAvalancheIdlePresentation";
import {TheCageModel} from "./server/TheCageModel";
import {TheCageReelsView} from "./reels/TheCageReelsView";
import {TheCageGameMode} from "./server/TheCageGameMode";
import {GraphicsPool} from "./utils/GraphicsPool";
import {TheCageWinView} from "./view/TheCageWinView";
import {TheCageForegroundElements} from "./view/TheCageForegroundElements";
import {TheCageFreesSpinReelsView} from "./reels/TheCageFreesSpinReelsView";
import {TheCageFreeSpinIdlePresentation} from "./gameflow/TheCageFreeSpinIdlePresentation";
import {TheCageFreeSpinBetPresentation} from "./gameflow/TheCageFreeSpinBetPresentation";
import {TheCageTransitionScreenView} from "./view/TheCageTransitionScreenView";
import {TheCageFreeSpinResultPresentation} from "./gameflow/TheCageFreeSpinResultPresentation";
import {TheCageFreeSpinWinPresentation} from "./gameflow/TheCageFreeSpinWinPresentation";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {TheCageStatics} from "./config/TheCageStatics";
import {RestoreUtils} from "./utils/RestoreUtils";
import {TheCageFreeSpinAvalancheIdlePresentation} from "./gameflow/TheCageFreeSpinAvalancheIdlePresentation";


export class TheCage extends SlotGame {
    public static model: TheCageModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: TheCageSound;
    public static backgroundElements: TheCageBackgroundElements;
    public static gameFlowController: GameFlowController;

    public static reelView:TheCageReelsView;
    public static graphicsPool:GraphicsPool;
    public static winView:TheCageWinView;
    public static freeSpinReelView:TheCageFreesSpinReelsView;
    public static transitionScreen:TheCageTransitionScreenView;


    constructor() {
        super();
    }

    private static getBetPrice():number {
        const betLevel:string = TheCage.apiPlugin.freeBets.hasFreeBets() ? TheCage.apiPlugin.freeBets.getBet() : TheCage.apiPlugin.betLevel.getLevel();
        let price:number = TheCage.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (TheCage.model.data.wasFeatureBuy || TheCage.model.data.boostedBetPlayed) {
            for (let index = 0; index < TheCage.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCage.model.initData.featureBuyTimesBetValue[index].name === TheCage.model.buyFeatureName) {
                    price *= TheCage.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private static getAccumulatedRoundWin():number {
        return TheCage.model.data.accumulatedRoundWin;
    }

    public static isWinBelowStake():boolean {
       return TheCage.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBetPrice());
    }

    public static isWinAboveStake():boolean {
        return this.getAccumulatedRoundWin() > this.getBetPrice();
    }

    getNoWinGameData(): any {
        return {
            "reels": [
            [
                "M4",
                "M4",
                "L2"
            ],
            [
                "L3",
                "L5",
                "L1",
                "L1"
            ],
            [
                "L4",
                "L4",
                "L2"
            ],
            [
                "L5",
                "L3",
                "L3",
                "L1"
            ],
            [
                "L4",
                "M3",
                "M3"
            ],
            [
                "L1",
                "L3",
                "L3",
                "L5"
            ],
            [
                "L4",
                "L2",
                "M5"
            ]
        ],
            "evaluatedArea": [
            [
                "M4",
                "M4",
                "L2"
            ],
            [
                "L3",
                "L5",
                "L1",
                "L1"
            ],
            [
                "L4",
                "L4",
                "L2"
            ],
            [
                "L5",
                "L3",
                "L3",
                "L1"
            ],
            [
                "L4",
                "M3",
                "M3"
            ],
            [
                "L1",
                "L3",
                "L3",
                "L5"
            ],
            [
                "L4",
                "L2",
                "M5"
            ]
        ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "totalAvalancheRoundWinnings": 0,
            "playedBetValue": 1,
            "accumulatedFsWin": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "scatterPositionsEnteringFreespin": [],
            "featureBuyTimesBetValue": [
            {
                "name": "FREESPIN",
                "type": "FREESPIN",
                "price": 68
            },
            {
                "name": "FREESPIN_LEVEL3",
                "type": "FREESPIN",
                "price": 198
            },
            {
                "name": "FREESPIN_LEVEL5",
                "type": "FREESPIN",
                "price": 498
            },
            {
                "name": "LUCKY_DRAW",
                "type": "FREESPIN",
                "price": 279
            }
        ],
            "wasFeatureBuy": false,
            "totalWays": 5184,
            "brokeTheBank": false,
            "symbolsAfterTumbleForClient": [
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ],
            "persistantBaseMultiplier": 1,
            "wildMiningMap": [
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ]
        ],
            "allWildMiningPositions": [],
            "symbolsAfterTumblePrev": [
            [
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK",
                "BLANK"
            ],
            [
                "BLANK",
                "BLANK",
                "BLANK"
            ]
        ],
            "persistantBaseMultiplierBefore": 1,
            "deleteMap": [
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false
            ]
        ],
            "fsLevel": -1,
            "nBNcollectedInFSAfter": [
            0,
            0,
            0,
            0,
            0
        ],
            "additionalFSadded": 0,
            "featuresActive": [
            false,
            false,
            false,
            false
        ],
            "featuresUsedBefore": [
            false,
            false,
            false,
            false
        ],
            "featuresUsedAfter": [
            false,
            false,
            false,
            false
        ],
            "symbolSizes": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ],
            "symbolSizesAfterTumble": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ],
            "nBNcollectedInFSBefore": [
            0,
            0,
            0,
            0,
            0
        ],
            "fsLevelEnterWith": 0
        }
    }


    public getSymbolString(key:string, data:{3:number, 4:number, 5:number, 6:number, 7: number, 8: number, 9:number}):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">9</span>
                    <span class="multiplier" data-multiplier="${data[9] * 0.05}">${data[9] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">8</span>
                    <span class="multiplier" data-multiplier="${data[8] * 0.05}">${data[8] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">7</span>
                    <span class="multiplier" data-multiplier="${data[7] * 0.05}">${data[7] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;


    }

    public getPaytable():Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name:"Paytable",
            url:"nolimit/screens/paytable.mustache"
        });


        let symbolDataValueData = TheCageStatics.defaultSymbolValues;
        if (TheCage.model?.symbolValues) {
            symbolDataValueData = TheCage.model?.symbolValues;
            console.log("Using symbolValues from INIT data");
        } else {
            console.log("Using default symbolValues ");
        }

        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {

                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        });
    }


    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            TheCage.model = new TheCageModel(SlotGame.apiPlugin, true);
            TheCage.gameFlowController = new GameFlowController(SlotGame.apiPlugin, TheCage.model);
            TheCage.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const normalBet = new TheCageBetPresentation();
            const normalResult = new TheCageNormalResultPresentation();
            const normalWinPres = new TheCageWinPresentation();

            TheCage.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new TheCageIdleNormalPresentation()],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));
            TheCage.gameFlowController.addGameModeFlowStatePresentationMap(TheCageGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE,  new TheCageAvalancheIdlePresentation()],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));

            const freespinBet = new TheCageFreeSpinBetPresentation();
            const freespinResult = new TheCageFreeSpinResultPresentation();
            const freespinWinPres = new TheCageFreeSpinWinPresentation();

            TheCage.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new TheCageFreeSpinIdlePresentation()],
                [FlowState.BET, freespinBet],
                [FlowState.RESULT, freespinResult],
                [FlowState.WIN, freespinWinPres]
            ]));
            TheCage.gameFlowController.addGameModeFlowStatePresentationMap(TheCageGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new TheCageFreeSpinAvalancheIdlePresentation()],
                [FlowState.RESULT, freespinResult],
                [FlowState.WIN, freespinWinPres]
            ]));

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(TheCageGameAssets.RESOURCES_GROUPS);
            TheCage.assetLoader = new AssetLoader(TheCage.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), TheCage.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                RestoreUtils.startupGame();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            TheCage.gameFlowController.start();
            TheCage.soundPlayer.switchMusic(TheCage.model.data.mode);
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        TheCage.graphicsPool = new GraphicsPool();
        TheCage.soundPlayer = new TheCageSound();

        //Static views
        TheCage.backgroundElements = new TheCageBackgroundElements();
        TheCage.reelView = new TheCageReelsView();
        TheCage.freeSpinReelView = new TheCageFreesSpinReelsView();
        TheCage.winView = new TheCageWinView();
        TheCage.transitionScreen = new TheCageTransitionScreenView();

        NolimitApplication.addLayerAt(TheCage.transitionScreen.name, TheCage.transitionScreen, 0);
        NolimitApplication.addLayerAt(TheCage.winView.name, TheCage.winView, 0);
        NolimitApplication.addLayerAt(TheCage.freeSpinReelView.name, TheCage.freeSpinReelView, 0);
        NolimitApplication.addLayerAt(TheCage.reelView.name, TheCage.reelView, 0);
        NolimitApplication.addLayerAt(TheCage.backgroundElements.name, TheCage.backgroundElements, 0);
    }
}